import FacebookButton from './FacebookButton';

export default FacebookButton;
